import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import Spinner from '@stubhub/react-spinner';

import {getDeliveryNameFromMatchedIds} from '../../../../components/react-event-deliveryName';
import NoFullfillmentInfo from '../no-fulfillment-info';

const DeliveryInfo = (
  {
    listingId,
    getDeliveryData,
    destroy,
    fulfillmentData = {},
    loading,
    listingLoading,
    isToday,
    deliveryMethodFromDeliveryExpectations,
    date,
    error,
  },
  {globalRegistry}
) => {
  const selectedShortInstruction = useRef(null);
  const deliveryDate = useRef(null);
  const selectedName = useRef(null);
  const [hasDeliveryMethod, setHasDeliveryMethod] = useState(null);

  useEffect(() => {
    getDeliveryData(listingId);

    return () => {
      destroy();
    };
  }, [listingId, getDeliveryData, destroy]);

  useEffect(() => {
    if (!listingLoading && !loading) {
      if (deliveryMethodFromDeliveryExpectations) {
        const currentLocale = globalRegistry?.getCurrentLocale();
        const options = {month: 'short', day: 'numeric', year: 'numeric', weekday: 'short'};
        deliveryDate.current = date.toLocaleDateString(currentLocale, options);
      }

      const {fulfillmentWindows = []} = fulfillmentData;
      const [availableFullfillment] = fulfillmentWindows;

      if (availableFullfillment) {
        const selectedDeliveryId = [];
        const {deliveryMethod: selectedDeliveryMethod} = availableFullfillment;
        selectedShortInstruction.current = selectedDeliveryMethod && selectedDeliveryMethod.shortInstruction;
        selectedDeliveryId.push(selectedDeliveryMethod.deliveryTypeId);
        selectedName.current = getDeliveryNameFromMatchedIds(selectedDeliveryId);
      }

      setHasDeliveryMethod(!!(selectedName.current && selectedShortInstruction.current && deliveryDate.current));
    }
  }, [loading, listingLoading, fulfillmentData, date, globalRegistry, deliveryMethodFromDeliveryExpectations]);

  if (listingLoading || loading) {
    return <Spinner />;
  }

  if (hasDeliveryMethod !== null && !hasDeliveryMethod && error) {
    return <NoFullfillmentInfo />;
  }

  return (
    <div className="RoyalBuildYourOrder__deliveryContainer">
      <div className="RoyalBuildYourOrder__deliveryContainer__header">{selectedName.current}</div>
      <div className="RoyalBuildYourOrder__deliveryContainer__content">
        {selectedShortInstruction.current}
        &nbsp;
        {isToday ? (
          <span className="RoyalBuildYourOrder__deliveryContainer_deliveryDate RoyalBuildYourOrder--bold">
            <FormattedMessage id="event-royal.react-build-your-order.delivery.info" defaultMessage="Today" />
          </span>
        ) : (
          deliveryDate.current && (
            <time
              className="RoyalBuildYourOrder__deliveryContainer_deliveryDate RoyalBuildYourOrder--bold"
              dateTime={deliveryDate.current}
            >
              {deliveryDate.current}
            </time>
          )
        )}
      </div>
    </div>
  );
};

DeliveryInfo.propTypes = {
  getDeliveryData: PropTypes.func.isRequired,
  listingLoading: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  fulfillmentData: PropTypes.object,
  isToday: PropTypes.bool,
  deliveryMethodFromDeliveryExpectations: PropTypes.object,
  date: PropTypes.instanceOf(Date),
  listingId: PropTypes.number,
  destroy: PropTypes.func.isRequired,
  error: PropTypes.bool,
};

DeliveryInfo.contextTypes = {
  globalRegistry: PropTypes.object,
};

export default DeliveryInfo;
